import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV_LINKS, COMPANIES, LOGO_GROUP, CONTACT } from "@/data/content";

export const Footer = () => (
    <footer className="grain relative overflow-hidden bg-[#0A0D20]" data-testid="main-footer">
        <div className="pointer-events-none absolute -bottom-10 left-0 select-none font-display text-[22vw] font-semibold leading-none tracking-tight text-outline opacity-60">
            MS GROUP
        </div>
        <div className="relative mx-auto max-w-[1440px] px-6 pb-10 pt-16 md:px-12 lg:px-20">
            <div className="grid gap-14 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
                <div>
                    <img src="/assets/logo-ms-group-white.png" alt="MS Group" className="h-16 w-auto object-contain" />
                    <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/55">
                        A diversified Indian business group building enduring businesses across hybrid seeds, FMCG,
                        real estate and healthcare — rooted in trust since 2014.
                    </p>
                    <p className="mt-6 text-xs uppercase tracking-[0.3em] text-[#F16622]">Est. 2014 · Hyderabad, India</p>
                </div>

                <div>
                    <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-white/40">Group Companies</h4>
                    <ul className="mt-6 space-y-3">
                        {COMPANIES.map((c) => (
                            <li key={c.id}>
                                {c.url ? (
                                    <a
                                        href={c.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        data-testid={`footer-company-${c.id}`}
                                        className="group inline-flex items-center gap-1.5 text-sm text-white/70 transition-colors hover:text-white"
                                    >
                                        {c.name}
                                        <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
                                    </a>
                                ) : (
                                    <span className="text-sm text-white/70">{c.name}</span>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-white/40">Navigate</h4>
                    <ul className="mt-6 space-y-3">
                        {NAV_LINKS.map((l) => (
                            <li key={l.to}>
                                <Link
                                    to={l.to}
                                    data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                                    className="link-sweep text-sm text-white/70 transition-colors hover:text-white"
                                >
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-white/40">Corporate Office</h4>
                    <address className="mt-6 space-y-2 text-sm not-italic leading-relaxed text-white/70">
                        <p>{CONTACT.office}</p>
                        {CONTACT.addressLines.map((a) => (
                            <p key={a}>{a}</p>
                        ))}
                        <p className="pt-2">
                            <a href={`mailto:${CONTACT.email}`} className="text-white transition-colors hover:text-[#F16622]">
                                {CONTACT.email}
                            </a>
                        </p>
                        <p>{CONTACT.phone}</p>
                    </address>
                </div>
            </div>

            <div className="mt-20 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center">
                <p className="text-xs text-white/40">© 2026 MS Group. All rights reserved.</p>
                <p className="text-xs uppercase tracking-[0.25em] text-white/40">
                    Strong Roots. Diverse Businesses. One Vision.
                </p>
            </div>
        </div>
    </footer>
);
